module.exports = __webpack_public_path__ + "b78588adcedbf0186665d5dc7b4943a2.svg";